import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=a0646488&"
import script from "./orderRecord.vue?vue&type=script&lang=js&"
export * from "./orderRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports